import { DssReports } from './dss-reports';
import { Report } from './report';

export class VerificationResponseData {

  base64Policy: string;
  newReport: Report;
  previousReport: Report;
  dssReports: DssReports;
  previousDssReports: DssReports;

  constructor() {
  }
}
